import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {required} from "../../../../../../../shared/utils";
import {EditPermissions} from "../../../../../../../shared/models";
import {getEditTypes} from "../../../delegatorUtils";


export class EndFlowNode {
    integration: any = {};

    constructor(rawValue: {}) {
        this.integration = {
            ...rawValue,
            "integrationType": "endNode",
            "endNode": {
                "endNodeType": "endFlow"
            }
        };
    }

    static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {

        const {editFlows} = getEditTypes(editPermissions);

        const integration = stepData?.integration;

        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: integration?.name ? integration.name : '',
                disabled: !editFlows
            }),
            description: new UntypedFormControl({
                value: integration?.description ? integration.description : '',
                disabled: !editFlows
            }, required('Description')),
        });
    }


    get getStepData(): {} {
        return {
            integration: this.integration,
            'type': 'integration',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

}


// stepX:
//     integration:
//         integrationType: "endNode"
//         name: "Callback ApiEndNode"
//         description: "Callback ApiEndNode"
//         endNode:
//             endNodeType: "end_flow"
//     type: "integration"
//     metadata:
//         stepUniqueID: "XXXX-XXXX-XXX"
